import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ReportesComponent } from './pages/reportes/reportes.component';
import { LoginComponent } from './pages/login/login.component';
import { NuevogastoComponent } from './pages/nuevogasto/nuevogasto.component';
import { AuthGuardService } from './servicios/auth-guard.service';
//guards
import { UserGuardService } from "./servicios/guards/user-guard.service";
import { MultiUserGuardService } from "./servicios/guards/multi-user.service";
import { PagosUserGuardService } from "./servicios/guards/pagos-user.service";
import { JorgeGuardService } from "./servicios/guards/jorge-guard.service";
import { ContadorGuardService } from "./servicios/guards/contador-guard.service";
//coponentes
import { VergastosComponent } from './pages/vergastos/vergastos.component';
import { VerdetallesComponent } from './pages/vergastos/verdetalles/verdetalles.component';
import { VerdetalleComponent } from './pages/vergastos/verdetalles/verdetalle/verdetalle.component';
import { VergastosPagosComponent } from './pages/pagos/vergastos-pagos/vergastos-pagos.component';
import { VerdetallesPagosComponent } from './pages/pagos/vergastos-pagos/verdetalles-pagos/verdetalles-pagos.component';
import { ChanguepassComponent } from './pages/changuepass/changuepass.component';
import { JorgeComponent } from './pages/jorge/jorge.component';
//datepicker en argent
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { registerLocaleData } from '@angular/common';
// importar locales
import localePy from '@angular/common/locales/es-PY';
import localePt from '@angular/common/locales/pt';
import localeEn from '@angular/common/locales/en';
import { DetallesJorgeComponent } from './pages/jorge/detalles-jorge/detalles-jorge.component';
import { PrintComponent } from './pages/shared/print/print.component';
import { PrintGastosComponent } from './pages/shared/print/print-gastos/print-gastos.component';
import { ContadorComponent } from './pages/contador/contador.component';
import { NuevofondofijoComponent } from './pages/nuevofondofijo/nuevofondofijo.component';
import { NuevaopComponent } from './pages/nuevaop/nuevaop.component';
import { PlandecuentasComponent } from './pages/contador/plandecuentas/plandecuentas.component';
import { ImpresionOpComponent } from './pages/nuevaop/impresion-op/impresion-op.component';
import { VeropComponent } from './pages/nuevaop/verop/verop.component';
import { CGComponent } from './pages/cg/cg.component';
import { CargaComponent } from './pages/sideu/carga/carga.component';
import { SinomytComponent } from './pages/sinomyt/sinomyt.component';
import { EmpresasComponent } from './pages/sideu/empresas/empresas.component';
import { ConsultaComponent } from './pages/sideu/consulta/consulta.component';
import { ImportadorComponent } from './pages/importador/importador.component';
import { ImportadorallComponent } from './pages/importadorall/importadorall.component';
import { ImportadorallTransfComponent } from './pages/importadorall-transf/importadorall-transf.component';
import { ReporteDeudasComponent } from './pages/reporte-deudas/reporte-deudas.component';
import { ReporteBeneficiariosComponent } from './pages/reporte-beneficiarios/reporte-beneficiarios.component';
import { LiquidacionesComponent } from './pages/liquidaciones/liquidaciones.component';
import { LiquidacionesGuardadasComponent } from './pages/liquidaciones-guardadas/liquidaciones-guardadas.component';
import { ConfiguracionComponent } from './pages/configuracion/configuracion.component';
// registrar los locales con el nombre que quieras utilizar a la hora de proveer
registerLocaleData(localePy, 'es');
registerLocaleData(localePt, 'pt');
registerLocaleData(localeEn, 'en');
//registerLocaleData(localeEsAR, 'es-Ar');
var appRoutes = [
    { path: 'home', component: HomeComponent },
    {
        path: 'reportes',
        component: ReportesComponent,
        canActivate: [AuthGuardService, ContadorGuardService]
    },
    { path: 'login', component: LoginComponent },
    { path: 'changepass', component: ChanguepassComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'nuevogasto',
        component: NuevogastoComponent,
        canActivate: [AuthGuardService, MultiUserGuardService]
    },
    { path: 'vergastos',
        component: VergastosComponent,
        canActivate: [AuthGuardService, UserGuardService]
    },
    { path: 'verdetalles',
        component: VerdetallesComponent,
        canActivate: [AuthGuardService, UserGuardService]
    },
    { path: 'verdetalle',
        component: VerdetalleComponent,
        canActivate: [AuthGuardService, UserGuardService]
    },
    { path: 'vergastos-pagos',
        component: VergastosPagosComponent,
        canActivate: [AuthGuardService, PagosUserGuardService]
    },
    { path: 'verdetalles-pagos',
        component: VerdetallesPagosComponent,
        canActivate: [AuthGuardService, PagosUserGuardService]
    },
    { path: 'vergastos-jorge',
        component: JorgeComponent,
        canActivate: [AuthGuardService, JorgeGuardService]
    },
    { path: 'verdetalles-jorge',
        component: DetallesJorgeComponent,
        canActivate: [AuthGuardService, JorgeGuardService]
    },
    { path: 'print',
        component: PrintComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'print-gastos',
        component: PrintGastosComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'contador',
        component: ContadorComponent,
        canActivate: [AuthGuardService, ContadorGuardService]
    },
    { path: 'nuevofondofijo',
        component: NuevofondofijoComponent,
        canActivate: [AuthGuardService, JorgeGuardService]
    },
    { path: 'nuevaop',
        component: NuevaopComponent,
        canActivate: [AuthGuardService, JorgeGuardService]
    },
    { path: 'impresionorden',
        component: ImpresionOpComponent,
        canActivate: [AuthGuardService, JorgeGuardService]
    },
    { path: 'verop',
        component: VeropComponent,
        canActivate: [AuthGuardService, JorgeGuardService]
    },
    { path: 'plandecuentas',
        component: PlandecuentasComponent,
        canActivate: [AuthGuardService, ContadorGuardService]
    },
    { path: 'cgimage',
        component: CGComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'cargar',
        component: CargaComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'sinomyt',
        component: SinomytComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'empresas',
        component: EmpresasComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'consultar',
        component: ConsultaComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'importador',
        component: ImportadorComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'impo-nominas',
        component: ImportadorallComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'impo-transferencias',
        component: ImportadorallTransfComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'reporte-deudas',
        component: ReporteDeudasComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'reporte-beneficiarios',
        component: ReporteBeneficiariosComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'liquidaciones',
        component: LiquidacionesComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'liquidaciones-guardadas',
        component: LiquidacionesGuardadasComponent,
        canActivate: [AuthGuardService]
    },
    { path: 'configuracion',
        component: ConfiguracionComponent,
        canActivate: [AuthGuardService]
    },
    { path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    { path: '**',
        redirectTo: '/home',
        pathMatch: 'full'
    }
];
var ɵ0 = MAT_MOMENT_DATE_FORMATS;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
